/**
 * @generated SignedSource<<ef5f1184c970d028986210598b03ba1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useDittoAppConnectionQuery$variables = {
  appId: string;
  skip: boolean;
};
export type useDittoAppConnectionQuery$data = {
  readonly viewer: {
    readonly appById?: {
      readonly cloudUrls: ReadonlyArray<{
        readonly url: string;
      }>;
      readonly createdAt: string;
      readonly hydraCluster: {
        readonly sdkVersion: string | null;
      } | null;
    } | null;
  };
};
export type useDittoAppConnectionQuery = {
  response: useDittoAppConnectionQuery$data;
  variables: useDittoAppConnectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "appId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sdkVersion",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDittoAppConnectionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "skip",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "App",
                "kind": "LinkedField",
                "name": "appById",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AppDomainStatus",
                    "kind": "LinkedField",
                    "name": "cloudUrls",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HydraCluster",
                    "kind": "LinkedField",
                    "name": "hydraCluster",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDittoAppConnectionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "condition": "skip",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "App",
                "kind": "LinkedField",
                "name": "appById",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AppDomainStatus",
                    "kind": "LinkedField",
                    "name": "cloudUrls",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HydraCluster",
                    "kind": "LinkedField",
                    "name": "hydraCluster",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "74e28d261417b3207fe73ccfe2c01df4",
    "id": null,
    "metadata": {},
    "name": "useDittoAppConnectionQuery",
    "operationKind": "query",
    "text": "query useDittoAppConnectionQuery(\n  $appId: ID!\n  $skip: Boolean!\n) {\n  viewer {\n    appById(id: $appId) @skip(if: $skip) {\n      createdAt\n      cloudUrls {\n        url\n        id\n      }\n      hydraCluster {\n        sdkVersion\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "51335bf766db574c4ecfcd59a47c60f8";

export default node;
